// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__-IalT","fileBtn":"File_fileBtn__3gii-","closeBtn":"File_closeBtn__2aQSY","fileSelected":"File_fileSelected__2VGGU","disabled":"File_disabled__3Q5Ud"};